import { render, staticRenderFns } from "./arrow-up.vue?vue&type=template&id=228ebddc&scoped=true&"
import script from "./arrow-up.vue?vue&type=script&lang=js&"
export * from "./arrow-up.vue?vue&type=script&lang=js&"
import style0 from "./arrow-up.vue?vue&type=style&index=0&id=228ebddc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228ebddc",
  null
  
)

export default component.exports